<template>
  <div class="cdjj-wrapper" v-loading="loading" v-if="refresh">
    <div class="cdjj-header">
      <h2>科目管理</h2>
      <div class="btn">
        <el-button plain @click="addSubject()" v-if="$_has('zledu.jiaoxue.sourcesubject.save')">添加科目</el-button>
      </div>
    </div>
    <div class="cdjj-table">
      <el-table
        :data="tableData"
        style="width: 100%"
        :height="height"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        class="collegeTable"
        :empty-text="empty"
      >
        <el-table-column prop="subjectName" label="科目" width="300"></el-table-column>
        <el-table-column label="已有课程" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.subjectCourses == 0 ? '——': scope.row.subjectCourses + '门' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="老师" prop="userName" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.subjectTeachers.map(item=>item.userName).join(',') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="科目编码" prop="code">
          <template slot-scope="scope">
            <span>{{ scope.row.code == '' ? '——': scope.row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="auto">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="adminRow(scope.$index, tableData)"
              round
              size="small"
              v-if="$_has('zledu.jiaoxue.sourcesubject.updatelist')"
            >管理目录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加科目 -->
    <el-dialog
      title="添加科目"
      :visible.sync="centereDialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="training-site">
        <el-row>
          <el-col :span="24">
            <span class="left-p">科目名称</span>
            <div class="left">
              <div class="content">
                <el-input v-model="subject" placeholder="请输入科目名称" maxlength="20"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="24" style="margin-top:10px;">
            <span class="left-p">科目编码</span>
            <div class="left">
              <div class="content">
                <el-input v-model="subjectCode" placeholder="请输入科目编码" maxlength="20"></el-input>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleTrainingeSite(true)" :disabled="disabled">保 存</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="no_wrap" :style="'height:'+(windowHeight-95)+'px'">
    <img src="../../../../../static/images/intercept-bg.png" alt="">
    <p>产品升级，请到 资源平台 查看</p>
  </div>
</template>
<script>
import * as api from '../../../../api/educationalApi'
let tid = 1000;
export default {
  data() {
    return {
      loading: true,
      restaurants: [],
      timeout: null,
      tableData: [],
      windowHeight: window.innerHeight,
      height: window.innerHeight - 170 + "px", // 表格高度根据窗口高度来决定
      empty: "暂无数据",
      tabs: [],
      centereDialogVisible: false,
      subject: "",
      subjectCode:'',
      professionId: "0",
      subjectId: "",
      title: "",
      auth:{
        save:false,
        delete:false,
        update:false,
        updatelist:false
      },
      refresh:false,
      disabled:false
    };
  },
  created() {
    // this.getSubjuectList(this.professionId);
  },
  methods: {
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex == 0) {
        return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important; padding-left:20px !important;";
      } else if (rowIndex === 0 && columnIndex == 2) {
        return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important; padding-left:20px !important;";
      } else {
        return "background:rgba(83,151,247,0.1);color:#999999;";
      }
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      if (row.columnIndex === 0 || row.columnIndex === 2) {
        return "text-align:left !important; padding-left:20px !important;";
      }
    },
    // 科目列表
    getSubjuectList(id) {
      api.querySubjectList(id).then(res => {
        if(res.code==0){
          this.tableData = res.data.data;
          this.loading = false;
        }else{
          this.$messageError(res.msg)
        }
      });
    },
    // 添加科目
    addSubject() {
      this.subject = "";
      this.subjectCode = "";
      this.centereDialogVisible = true;
      this.disabled = false;
    },
    // 添加科目保存
    handleTrainingeSite(type) {
      if (type) {
        if (this.subject && this.subjectCode) {
          api.addSubject({
            subjectName: this.subject,
            professionId:'2',
            code:this.subjectCode
          }).then(res => {
            if (res.code === "0") {
              this.disabled = true;
              this.centereDialogVisible = false;
              this.loading = true;
              this.$messageSuccess('添加科目保存成功')
              this.getSubjuectList(this.professionId);
            } else {
              this.$messageError(res.msg);
              return;
            }
          });
        } else {
          this.$messageError('科目名称和科目编码不能为空');
        }
      }
    },
    // 管理目录
    adminRow(index, rows) {
      let subjectId = rows[index].subjectId;
      let subjectName = rows[index].subjectName;
      let subjectCode = rows[index].code
      this.$router.push({
        path: '/educa/sourcesubject/dtails',
        query: {
          subjectId,
          subjectName,
          subjectCode
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.cdjj-wrapper {
  padding: 0 16px;
  .cdjj-header {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
    .btn {
      .el-button {
        float: right;
        padding: 7px 11px;
        border-color: #5397f7;
        color: #5397f7;
        font-size: 12px;
        &:hover {
          background: #5397f7;
          color: #fff;
        }
      }
    }
  }
  .cdjj-table {
    margin-top: 16px;
    .collegeTable {
      border: 1px solid #ebebeb;
      border-radius: 4px;
      border-bottom: 0;
    }
    /deep/ .el-button--small,
    .el-button--small.is-round {
      padding: 5px 15px;
      color: #5397f7;
    }
    /deep/ .el-table__empty-text {
      display: block;
      width: 200px;
      height: 200px;
      padding-top: 190px;
      color: #909399;
      box-sizing: border-box;
      background: url("../../../../../static/images/wujieguo.png") no-repeat;
    }
  }
  /deep/ .el-dialog__header {
    background: #edf4ff;
    border-radius: 8px 8px 0 0;
    height: 18px;
    &:before {
      width: 2px;
      height: 10px;
      background: rgba(83, 151, 247, 1);
      opacity: 1;
      border-radius: 4px;
    }
  }
  /deep/ .el-dialog__title {
    display: block;
    font-size: 14px;
    color: #5397f7;
    border-left: 2px solid #5397f7;
    padding-left: 5px;
    line-height: 10px;
  }
  /deep/ .el-dialog__footer {
    .el-button {
      width: 79px;
      height: 32px;
      line-height: 32px;
      padding: 0;
    }
  }
  .training-site {
    padding: 0 45px;
    .el-col-24 {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .left-p {
      float: left;
    }
    .left {
      float: left;
      .content {
        width: 260px;
      }
    }
  }
  /deep/ .material_tree {
    .el-tree-node > .el-tree-node__children {
      overflow: inherit;
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #edf4ff;
      border-left: 2px solid #5397f7;
    }

    .el-tree-node__content:hover {
      height: 34px;
      background: #edf4ff;
    }
  }
  /deep/ .el-tree-node__content {
    height: 34px;
    line-height: 34px;
  }
  /deep/ .el-tree-node__content > .el-tree-node__expand-icon {
    color: rgba(83, 151, 247, 1);
  }
  /deep/ .tree-icon {
    color: rgba(83, 151, 247, 1);
  }
  /deep/ .el-tree-node__expand-icon.is-leaf {
    color: transparent;
    cursor: default;
  }

  /deep/ .custom-tree-node {
    width: 80%;
    flex: 1 1 0%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    height: 100%;
  }
  .father {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 8px;
  }
  .child {
    padding-right: 9px;
    .el-button.is-round {
      padding: 4px 18px;
    }
  }
  .material-content {
    padding: 15px;
    overflow-y: auto;
    height: 329px;
    .material-aside {
      .material_chapters {
        position: relative;
        border-radius:4px;
        height: 32px;
        line-height: 32px;
        background: #5397F7;
        h3 {
          color: #FFFFFF;
          margin-left: 12px;
        }
        .add-btn {
          color: #5397F7;
          position: absolute;
          right: 8px;
          top: 4px;
          padding: 4px 18px;
        }
      }
      .material_CTreeCtrl {
        /deep/ .el-tree__empty-text {
            display: block;
            width: 100px;
            height: 100px;
            padding-top: 110px;
            top: 110px;
            color: #909399;
            box-sizing: border-box;
            background: url('../../../../../static/images/wujieguo.png') no-repeat;
        }
      }
    }
  }
}
.no_wrap{
  padding: 0 16px;
  background: #fff;
  margin: 16px 16px 0;
  border-radius: 4px;
  text-align: center;
  img{
    width: 300px;
    margin-top: 10%;
  }
  P{
    font-size: 14px;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educationalAdminMenu/sourceSubject.vue